import DebugPropertyCard from 'automation-ui-canvas/components/panels/debugger-panel/DebugPropertyCard';
import DebugCardContainer from 'automation-ui-canvas/components/panels/debugger-panel/DebugCardContainer';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Text } from 'foundations-components/components/Text';
import { AccordionItem } from 'foundations-components/transitional/components/AccordionItem';
import DataSourceName from 'automation-ui-formula-editor/data-sources/DataSourceName';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import DataSourcePropertyName from 'automation-ui-formula-editor/data-sources/DataSourcePropertyName';
import { jsx as _jsx } from "react/jsx-runtime";
export const ActionInputsSection = ({
  resolvedDataTokensData
}) => {
  const resolvedDataTokens = resolvedDataTokensData === null || resolvedDataTokensData === void 0 ? void 0 : resolvedDataTokensData.resolvedDataTokens;
  if (!resolvedDataTokens || !resolvedDataTokens.length) {
    return /*#__PURE__*/_jsx(DebugCardContainer, {
      backgroundColor: "fill-surface-default",
      borderColor: "border-core-default",
      children: /*#__PURE__*/_jsx(Text, {
        as: "p",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "debuggerPanel.step.outputs.noData"
        })
      })
    });
  }
  return resolvedDataTokens === null || resolvedDataTokens === void 0 ? void 0 : resolvedDataTokens.map(token => {
    return /*#__PURE__*/_jsx(AccordionItem, {
      marginBlock: "200",
      title: /*#__PURE__*/_jsx(FormattedReactMessage, {
        message: "debuggerPanel.step.outputs.dataSource",
        options: {
          dataSource: /*#__PURE__*/_jsx(DataSourceName, {
            dataSourcePrefix: token.dataSource
          })
        }
      }),
      defaultOpen: true,
      children: token === null || token === void 0 ? void 0 : token.resolvedTokens.map(resolvedToken => {
        const tokenString = `${token.dataSource}.${resolvedToken.fieldName}`;
        return /*#__PURE__*/_jsx(DebugPropertyCard, {
          property: /*#__PURE__*/_jsx(DataSourcePropertyName, {
            token: tokenString
          }),
          value: resolvedToken.value,
          token: tokenString
        }, tokenString);
      })
    }, token.dataSource);
  });
};